<script setup>
// Chrome-less calculator for other sites' iframes. The tool page renders inside with
// ToolShell in embed mode: calculator only, a credit link, noindex and a canonical to
// the tool page (components/tools/ToolShell.vue).
import { toolEmbeds } from '~/data/tool-embeds.mjs';
import HourlyRateCalculator from '~/pages/tools/hourly-rate-calculator.vue';
import LateFeeCalculator from '~/pages/tools/late-fee-calculator.vue';
import RetainerCalculator from '~/pages/tools/retainer-calculator.vue';
import ConsultingRateCalculator from '~/pages/tools/consulting-rate-calculator.vue';
import ProfitMarginCalculator from '~/pages/tools/profit-margin-calculator.vue';
import DepositCalculator from '~/pages/tools/deposit-calculator.vue';
import InvoiceDueDateCalculator from '~/pages/tools/invoice-due-date-calculator.vue';

definePageMeta({ layout: false });

const calculators = {
  'hourly-rate-calculator': HourlyRateCalculator,
  'late-fee-calculator': LateFeeCalculator,
  'retainer-calculator': RetainerCalculator,
  'consulting-rate-calculator': ConsultingRateCalculator,
  'profit-margin-calculator': ProfitMarginCalculator,
  'deposit-calculator': DepositCalculator,
  'invoice-due-date-calculator': InvoiceDueDateCalculator,
};

const route = useRoute();
const tool = toolEmbeds.find((entry) => entry.slug === route.params.tool);
if (!tool || !calculators[tool.slug]) {
  throw createError({ statusCode: 404, statusMessage: 'Calculator not found', fatal: true });
}

provide('toolEmbed', true);
useHead({ bodyAttrs: { class: 'tool-embed' } });
</script>

<template>
  <!-- Same type setup as layouts/default.vue, which layout: false skips. -->
  <div class="font-poppins antialiased text-slate-950 tracking-normal">
    <component :is="calculators[tool.slug]" />
  </div>
</template>

<style>
/* The calculator is light-only (ToolShell), so the frame stays light in dark mode too. */
body.tool-embed {
  background: #f7f8f9;
}
</style>
